import { useSelector } from 'react-redux';
import { useState } from 'react';
import { ShiftsContainer } from '../ShiftInformation.styles';
import ShiftTimeEntry from './ShiftTimeEntry/ShiftTimeEntry';
import BreakTimes from './BreakTimes/BreakTimes';
import { selectShiftStatus } from '../../../redux/shifts/shiftsSlice';
import { selectShiftsByAssignment } from '../../../redux/slices/shiftSlice';
import { useShiftTimeValidation } from '../../../utils/Hooks/shifts/useShiftTimeValidation';
import { SHIFT_TYPES } from '../../../utils/constants/shiftConstants';
import PropTypes from 'prop-types';

/**
 * Container component for managing all shift time-related elements:
 * - Start time
 * - End time
 * - Breaks
 *
 * Handles time validation, UI state, and updates for the entire shift schedule.
 *
 * @param {Object} props
 * @param {Object} props.handleShiftUpdate - Function to update shift data
 */
const ShiftTimesContainer = ({ shift, handleShiftUpdate, disabled }) => {
  const shiftsByAssignment = useSelector(selectShiftsByAssignment);
  const updatedStatus = useSelector(selectShiftStatus);
  const isBreaksLoading = useSelector((state) => state.breaks.loading);

  // Time picker visibility state
  const [openStartTimePicker, setOpenStartTimePicker] = useState(false);
  const [openEndTimePicker, setOpenEndTimePicker] = useState(false);

  // Get time validation logic
  const { handleStartTimeChange, handleEndTimeChange, shiftErrorMessage } = useShiftTimeValidation(
    shift,
    shiftsByAssignment,
    handleShiftUpdate
  );

  return (
    <ShiftsContainer>
      <ShiftTimeEntry
        shift={shift}
        openTimePicker={openStartTimePicker}
        setOpenPicker={setOpenStartTimePicker}
        onTimeChange={handleStartTimeChange}
        error={shiftErrorMessage.type === SHIFT_TYPES.START ? shiftErrorMessage.message : null}
        disabled={disabled}
        isStartTime={true}
      />
      <BreakTimes shift={shift} loading={isBreaksLoading || updatedStatus === 'LOADING'} disabled={disabled} />
      <ShiftTimeEntry
        shift={shift}
        openTimePicker={openEndTimePicker}
        setOpenPicker={setOpenEndTimePicker}
        onTimeChange={handleEndTimeChange}
        error={shiftErrorMessage.type === SHIFT_TYPES.END ? shiftErrorMessage.message : null}
        disabled={disabled}
        isStartTime={false}
      />
    </ShiftsContainer>
  );
};

ShiftTimesContainer.propTypes = {
  shift: PropTypes.object.isRequired,
  handleShiftUpdate: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ShiftTimesContainer;
